import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import axios from 'axios'
import Qs from 'qs'

Vue.config.productionTip = false

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_SERVER,
  withCredentials: true,
  headers: {
    Accept: 'application/ld+json'
  },
  paramsSerializer: (params) => (Qs.stringify(params))
})
Vue.prototype.$http = axiosInstance
Vue.prototype.$server = process.env.VUE_APP_BACKEND_SERVER
Vue.prototype.$directory = process.env.VUE_APP_BACKEND_DIRECTORY

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
